import { Skeleton } from 'antd'
import classNames from 'classnames'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

import { Flex, Text } from 'components/uiKit'

import s from './Timer.module.scss'

type TimerProps = {
  type: 'deadline' | 'timeLeft'
  timeLeftInSeconds?: number
  endDate?: string
  returnText?: boolean
  loading?: boolean
}

export const Timer = observer(
  ({ type = 'deadline', timeLeftInSeconds = 0, endDate, returnText = false, loading = false }: TimerProps) => {
    const timeBeforeCLoseInitial = type === 'deadline' ? dayjs(endDate).diff(dayjs()) : timeLeftInSeconds * 1000

    const [timeBeforeCLose, setTimeBeforeCLose] = useState(timeBeforeCLoseInitial)
    const [isTimeUp, setIsTimeUp] = useState(false)

    const classes = classNames(s.timer, {
      [s.red]: isTimeUp,
    })

    useEffect(() => {
      const interval = setInterval(() => {
        setTimeBeforeCLose(timeBeforeCLoseInitial)
      }, 1000)

      return () => clearInterval(interval)
    }, [endDate, timeLeftInSeconds])

    const checkTimeIsLeft = () => {
      const totalHours = Math.floor(timeBeforeCLose / (1000 * 60 * 60)) // Получаем часы

      if (totalHours < 1) {
        isTimeUp === false && setIsTimeUp(true)
        return true
      } else {
        isTimeUp === true && setIsTimeUp(false)
        return false
      }
    }

    const formatTimeLeft = (time: number | null) => {
      if (!time) {
        return '—'
      }

      checkTimeIsLeft()

      const totalHours = Math.floor(time / (1000 * 60 * 60)) // Получаем часы
      const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60)) // Получаем минуты

      let formattedTime = ''

      if (totalHours > 0) {
        formattedTime += `${totalHours} ч. `
      }

      if (minutes > 0) {
        formattedTime += `${minutes} мин.`
      }

      if (totalHours < 1 && minutes < 1) {
        return '0 ч. 0 мин.'
      }

      return formattedTime
    }

    return (
      <>
        {returnText &&
          (loading ? (
            <Skeleton.Input active size="small" />
          ) : (
            <Text type="danger">{formatTimeLeft(timeBeforeCLose)}</Text>
          ))}

        {!returnText && (
          <Flex className={classes}>
            {loading ? <Skeleton.Input active size="small" /> : formatTimeLeft(timeBeforeCLose)}
          </Flex>
        )}
      </>
    )
  },
)
